export default "__VITE_ASSET__ad639fb3__"